import { AlertProps } from 'components/Alert';
import { DEFAULT_ERROR_MESSAGE } from 'config';
import { AxiosCustomError } from './axios-custom-error.model';
import { CustomError } from './custom-error.model';

export function mapToAlertErrors(error: unknown): AlertProps {
  if (!error || typeof error !== 'object') {
    return {
      text: '',
    };
  }

  // AxiosCustomError Error - comes from axios interceptor
  if (error?.hasOwnProperty('customError')) {
    const { customError } = error as AxiosCustomError;
    if (customError.type === 'TECHNICAL' && customError.transactionId) {
      return {
        type: mapType(customError),
        text: `${customError.description} ID: ${customError.transactionId}`,
      };
    }
    return {
      type: mapType(customError),
      text: customError.description,
    };
  }

  // CustomError Error
  if (error?.hasOwnProperty('severity')) {
    const errorObject = error as CustomError;
    if (
      (errorObject.type === 'TECHNICAL' || errorObject.type === 'BUSINESS') &&
      errorObject.transactionId
    ) {
      return {
        type: mapType(errorObject),
        text: `${errorObject.description} ID: ${errorObject.transactionId}`,
      };
    }
    return {
      type: mapType(errorObject),
      text: errorObject.description,
    };
  }

  return {
    type: 'error',
    text: DEFAULT_ERROR_MESSAGE,
  };
}

export function mapType({
  severity = 'ERROR',
}: CustomError): AlertProps['type'] {
  const alertTypes = ['warning', 'info', 'error'];
  const lowerCaseError = severity.toLocaleLowerCase();

  return alertTypes.includes(lowerCaseError)
    ? (lowerCaseError as AlertProps['type'])
    : 'error';
}
